<template>
  <div class="container">
    <QueryFrame
        :disablePage="disablePage"
        @handlePage='handlePage'
        @handlePageSize='handlePageSize'

        :count="count"
        :current="page"
        >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix" placeholder='支持商品编码、通用名、商品名'></goodsSearchItem>
            <!-- <label>药品名称:</label>
            <lk-input :maxlength='100' class="item" placeholder='请输入，支持商品名、通用名' clearable v-model='query.nameMix'></lk-input> -->
          </div>
          <div class="queryItem">
            <label>批准文号/注册证号:</label>
            <lk-input :maxlength='100' class="item" placeholder='请输入' clearable v-model='query.approvalCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>剂型:</label>
            <lk-select v-model='query.dosageForm' class="item" filterable clearable>
              <lk-option v-for="(item,index) in dosageArr" :key="index" :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>储存条件:</label>
            <lk-select v-model='query.storageCondition' class="item" clearable>
              <lk-option v-for="(item,index) in storageConditionsArr" :key="index" :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>商品标签:</label>
            <lk-select v-model='query.labelIdList' class="item" filterable clearable multiple >
              <lk-option v-for="(item,index) in labels" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <!-- <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item" clearable  >
              <lk-option :value='1'>是</lk-option>
              <lk-option :value='2'>否</lk-option>
            </lk-select>
          </div> -->
          <div class="queryItem">
            <label>商品类型:</label>
            <goodsTypeCascader class="item"  v-model='query.type' ></goodsTypeCascader>
          </div>
          <div class="queryItem">
            <label>商品分类:</label>
            <TreeSelect :data="indicationTree" class="item" clearable v-model="query.categoryIdList"></TreeSelect>
          </div>
          <div class="queryItem">
            <label>生产企业:</label>
            <lk-input  class="item" placeholder='请输入' clearable v-model="query.producer"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clearForm">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="mb16">
        <lk-button class="mr8" type='primary' v-if="handlePermission('goodsAdd')" @click='addNew'>+ 新建基础商品</lk-button>
        <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('baseGoodsExport')" ></DownloadButton>
        </div>
        <lk-table  border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
    <lk-modal
    :title="isStop ? '停用商品' : '启用商品'"
    v-model="showReason"
    :footer-hide='true'
    width="400"
    :closable='false'
    :mask-closable='false'>
      <div style="display:flex;">
          <span class="warnIcon iconfont">&#xe613;</span> &nbsp;
          <h6 style="margin-top: 7px;font-size: 12px;">是否确认{{ isStop ? '停用' : '启用'}}此商品？</h6>
      </div>
      <div style="display:flex">
        <span v-if="isStop" class="redMark">*</span>
        <span :class="isStop ? 'stopReason' : 'reason'">{{ isStop ? '停用原因：' : '停用原因：' + stopReason}}</span>
      </div>
      <lk-input v-if="isStop" class="stopInput" placeholder='请输入停用原因' :maxlength="100" clearable v-model.trim="stopReason" type="textarea"></lk-input>
      <div class="bottomButton">
          <lk-button type='primary' :disabled="isStop ? stopReason == '' : false" @click="editGoods(editId)">确认</lk-button>
          <lk-button @click="showReason=false, getData()">取消</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import goodsBase from '../../../services/goods';
import utils from '../../../libs/utils';
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import goodsSearchItem from '../../../components/goodsSearchItem.vue';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins'; // 鉴权
import TreeSelect from '../../../components/treeSelect/treeSelect.vue';
import goodsTypeCascader from '../../../components/goodsTypeCascader.vue';
import DownloadButton from '../../../components/download/DownloadButton';

export default {
  name: 'BaseList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, TreeSelect, goodsSearchItem, goodsTypeCascader, DownloadButton,
  },
  computed: {

    ...mapGetters(['getNormalGoodsTypes']),

  },
  data() {
    return {
      stopReason: '',
      editId: '',
      isStop: true,
      showReason: false,
      labels: [],
      disablePage: false,
      dosageArr: [],
      drugMiniPackageUnitArr: ['', '盒'],
      qualityOfDrugsTypeArr: [],
      isImportArr: ['', '是', '否'],
      storageConditionsArr: [],
      indicationDicArray: [],
      indicationTree: [],
      query: {
        nameMix: '',
        approvalCode: '',
        dosageForm: null,
        spec: '',
        storageCondition: null,
        categoryIdList: [],
        labelIdList: [],
        producer: '',
        page: 0,
        size: 0,
      },
      params: {
        nameMix: '',
        approvalCode: '',
        dosageForm: null,
        spec: '',
        storageCondition: null,
        categoryIdList: [],
        labelIdList: [],
        producer: '',
        page: 0,
        size: 0,
      },
      columns: [
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名/商品名称', key: 'approvedDrugNames', minWidth: 156 },
        { title: '商品类型', key: 'typeString', minWidth: 156 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '药品规格', key: 'drugSpec', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 186 },
        { title: '批准文号/注册证号', key: 'approvalNumber', minWidth: 166 },
        { title: '剂型', key: 'dosageFormString', minWidth: 116 },
        { title: '最小包装单位', key: 'drugMiniPackageUnitString', minWidth: 166 },
        { title: '储存条件', key: 'storageConditionsString', minWidth: 116 },
        { title: '本位码', key: 'ndcNumber', minWidth: 116 },
        { title: '产地', key: 'countryOfOrigin', minWidth: 116 },
        { title: '质检标准', key: 'drugAcceptanceStandard', minWidth: 116 },
        { title: '批件号', key: 'drugRegApprovalCode', minWidth: 166 },
        { title: '批件有效期', key: 'periodDrugRegApproval', minWidth: 166 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '化学成分', key: 'chemicalComposition', minWidth: 116 },
        { title: '条形码', key: 'barCode', minWidth: 116 },
        { title: '是否进口', key: 'isImport', minWidth: 116 },
        {
          title: '商品标签', key: 'goodsLabelsString', minWidth: 156, tooltip: true,
        },
        { title: '商品分类', key: 'indicationDicString', minWidth: 156 },


        {
          title: '状态',
          key: 'goodsBaseStatus',
          minWidth: 116,
          fixed: 'right',
          render: (h, params) => (this.handlePermission('goodsBaseEnableDisable') ? h('lk-switch', {
            props: {
              size: 'large',
              value: params.row.goodsBaseStatus === 1,
              loading: params.row.loading,
            },
            on: {
              'on-change': (e) => {
                params.row.loading = true;
                this.showReason = true;
                if (e) {
                  this.isStop = false;
                  this.stopReason = params.row.disableReason;
                } else {
                  this.stopReason = '';
                  this.isStop = true;
                }
                this.editId = params.row.id;
              },
            },
          }, [
            h('span', {
              props: {
              },
              slot: 'open',

            }, '启用'),
            h('span', {
              props: {
              },
              slot: 'close',

            }, '禁用'),
          ]) : h('span', params.row.goodsBaseStatus === 1 ? '启用' : '禁用')),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          render: (h, params) => h('div', [
            this.handlePermission('goodsBaseView') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'goodsBaseView', params: { id: params.row.id, type: params.row.type } });
                },
              },
            }, '查看') : null,
            this.handlePermission('goodsBaseEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'goodsBaseEdit', params: { id: params.row.id, type: params.row.type } });
                },
              },
            }, '编辑') : null,
            this.handlePermission('storeFirst') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'storeFirst', params: { id: params.row.id } });
                },
              },
            }, '门店首营') : null,
            this.handlePermission('medicationEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'medicationEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑用药信息') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    this.getLabel();

    if (!this.handlePermission('goodsBaseView')
   && !this.handlePermission('goodsBaseEdit')
    && !this.handlePermission('storeFirst')) {
      this.columns = this.columns.slice(0, this.columns.length - 1);
    }
    this.fetchListIndications();
    this.getSelectArrs();
    this.handleSearch(true);
  },
  methods: {
    editGoods(id) {
      this.showReason = false;
      if (!this.isStop) {
        goodsBase.enableGoodsBase({ id }).then((responseData) => {
          if (responseData.data.status === 200) {
            this.$Message.success('基础商品启用');
            this.handleSearch();
            this.stopReason = '';
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        goodsBase.disableGoodsBase({ id, disableReason: this.stopReason }).then((responseData) => {
          if (responseData.data.status === 200) {
            this.$Message.success('基础商品禁用');
            this.handleSearch();
            this.stopReason = '';
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;

      params.queryCondition = utils.getQueryCondition('.queryContainer');
      goodsBase.exportGoodsBases(params).then((res) => {
        // utils.downLoadExcel(res, '销售明细查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clearForm() {
      this.query = {
        nameMix: '',
        approvalCode: '',
        dosageForm: null,
        spec: '',
        storageCondition: null,
        categoryIdList: [],
        labelIdList: [],
        producer: '',
        page: 0,
        size: 0,
      };
      this.indicationDicArray = '';
    },
    addNew() {
      this.$router.push({ name: 'goodsAdd' });
    },

    walkTreeIndications(item) {
      const res = {
        value: item.id,
        title: item.goodsIndicationDicName,
      };
      if (item.childGoodsIndicationDicVOs.length) {
        res.children = [];
        item.childGoodsIndicationDicVOs.forEach((data) => {
          res.children.push(this.walkTreeIndications(data));
        });
      }
      return res;
    },
    fetchListIndications() {
      goodsBase.listIndications().then((res) => {
        const status = res.data.status;
        const resData = [];
        if (status === 200) {
          const data = res.data.data;
          data.forEach((item) => {
            resData.push(this.walkTreeIndications(item));
          });
        }
        this.indicationTree = resData;
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.$route.params.create ? this.params.create = true : this.params.create = '';
      goodsBase.listGoodsBases(this.params).then((responseData) => {
        if (responseData.data.status === 200) {
          this.tableData = [];
          this.count = responseData.data.data.count;
          responseData.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item.goodsBase, result);
            result.drugRegApprovalCode = item.goodsBase.drugRegApprovalCode || item.goodsBase.importRegCertCode;
            result.periodDrugRegApproval = utils.exchangeTime(item.goodsBase.periodDrugRegApproval || item.goodsBase.periodImportRegCert);
            result.drugMiniPackageUnitString = item.drugMiniPackageUnitString;
            result.storageConditionsString = item.storageConditionsString;
            result.dosageFormString = item.dosageFormString;
            result.goodsLabelsString = item.goodsLabelsString;
            result.isImport = this.isImportArr[item.goodsBase.isImport];
            if (item.indicationDicString) {
              const regExp = new RegExp(',', 'g');
              result.indicationDicString = item.indicationDicString.replace(regExp, '/');
            }
            result.typeString = utils.handleGoodsTypeStr(item.goodsBase.type);
            result.loading = false;
            result.disableReason = item.goodsBase.disableReason || '';
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(responseData.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    getLabel() {
      goodsBase.listGoodsLabelCategories().then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          for (const key in data) {
            data[key].forEach((item) => {
              this.labels.push(item);
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getSelectArrs() {
      return new Promise((resolve) => {
        this.drugMiniPackageUnitArr = [];
        this.storageConditionsArr = [];
        this.qualityOfDrugsTypeArr = [];
        this.dosageArr = [];

        goodsBase.GoodsDictionary().then((res) => {
          if (res.data.status === 200) {
            res.data.data.forEach((item) => {
              switch (item.dictionaryType) {
                case 1:
                  this.dosageArr.push(item);
                  break;

                case 3:
                  this.drugMiniPackageUnitArr.push(item);

                  break;
                case 8:
                  this.qualityOfDrugsTypeArr.push(item);

                  break;
                case 9:
                  this.storageConditionsArr.push(item);

                  break;

                default:
                  break;
              }
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

.bottomButton{
    margin-left: 220px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}

  .warnIcon {
  color: orange;
  font-size: 20px;
};

.stopReason {
  margin-top:8px;
  margin-left: 4px;
  font-size: 12px;
}

.reason {
  margin-top:8px;
  font-size: 12px;
  margin-left: 25px;
}

.redMark {
  color: red;
  margin-top:6px;
  margin-left: 22px;
  font-size: 18px;
}

.stopInput{
  margin-left:22px;
  margin-right: 20px;
  width: 340px;
  margin-top: 0px;
}

</style>
